 /* eslint-disable */
import { accessNestedProperty } from "../../helpers/general";

const SORT_BY_MAP = {
    name: 'name',
    endDate: 'endDate'
  };

export const sortReviews = ({ reviews = [], sortBy, sortOrder }) => [...reviews].sort((a, b) => {
    const isAsc = sortOrder === 'asc';
    return isAsc ? accessNestedProperty(a, SORT_BY_MAP[sortBy]).localeCompare(accessNestedProperty(b, SORT_BY_MAP[sortBy]))
    : accessNestedProperty(b, SORT_BY_MAP[sortBy])
    .localeCompare(accessNestedProperty(a, SORT_BY_MAP[sortBy]));
});
